import { Injectable } from '@angular/core';
import { Notification } from '@api/models/notification';
import { RespuestaDatosPersonales } from '@api/models/respuesta-datos-personales';
import { RespuestaOtrosDatosPersona } from '@api/models/respuesta-otros-datos-persona';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  notificationKeys: string[];
  notifications: Notification[];

  constructor(private translateService: TranslateService) {}

  setNotifications(
    OtrosDatosPersona: RespuestaOtrosDatosPersona,
    DatosPersonales: RespuestaDatosPersonales
  ) {
    const verifiedkeys = ['indPbcHighRisk', 'fechaCaducidadDocumento', 'indPendingDocs', 'indPendingManualSign'];

    const clientData = Object.fromEntries(
      Object.entries({ ...OtrosDatosPersona, ...DatosPersonales }).filter(([key]) =>
        verifiedkeys.includes(key)
      )
    );


    const clientName = Object.fromEntries(
      Object.entries({ ...DatosPersonales }).filter(([key]) => key === 'nombreCliente')
    );

    
    if (clientData.indPbcHighRisk === true) {
      localStorage.setItem('indPbcHighRisk', clientData.indPbcHighRisk.toString());
    }

    this.notificationKeys = Object.keys(clientData).filter((key) => {
      const value = clientData[key];

      if (typeof value === 'boolean') {
        return value === true;
      }
      if (key === 'fechaCaducidadDocumento' && typeof value === 'string') {
        return this.shouldShowDocumentNotification(
          this.getExpirationDate(clientData.fechaCaducidadDocumento as string)
        );
      }

      return false;
    });
    this.notifications = [];
    this.notificationKeys.forEach((data) => {
      this.notifications.push(
        this.createNotificationBody(
          data,
          clientName.nombreCliente as string,
          clientData.fechaCaducidadDocumento as string
        )
      );
    });
  }

  getNotifications(): Notification[] {
    return this.notifications || [];
  }

  closeNotifications() {
    this.getNotifications().forEach((notification) => (notification.expanded = false));
  }

  sortNotificationsByPriority() {
    this.getNotifications().sort((a, b) => {
      if (a.priority && !b.priority) {
        return -1;
      } else if (!a.priority && b.priority) {
        return 1;
      } else {
        return 0;
      }
    });
  }

  createNotificationBody(data: string, name?: string, fechaDocumento?: string): Notification {
    let priority = false;
    let text = '';

    if (data === 'indPendingDocs') {
      data = this.translateService.instant("Notifications.notification_title_pending_upload_data_user");
      text = this.translateService.instant("Notifications.notification_description_pending_upload_data_user");
      priority = false;
    }

    if (data === 'fechaCaducidadDocumento' && name) {
      const expireDate = this.getExpirationDate(fechaDocumento);
      const isExpired = this.isDocumentExpired(expireDate);

      data = isExpired
        ? this.translateService.instant("Notifications.notification_title_document_expired")
        : this.translateService.instant("Notifications.notification_title_document_nearing_expiration");

      text = isExpired
        ? this.translateService.instant("Notifications.notification_description_document_expired")
        : this.translateService.instant("Notifications.notification_description_document_nearing_expiration");

      priority = isExpired;
    }

    if (data === 'indPbcHighRisk') {
      data = this.translateService.instant("Notifications.notification_title_highrisk");
      text = this.translateService.instant("Notifications.notification_description_update_data_user");
      priority = true;
    }

    if (data === 'indPendingManualSign') {
      data = this.translateService.instant("Notifications.notification_title_pending_manual_sign");
      text = this.translateService.instant("Notifications.notification_description_pending_manual_sign");
    }

    return {
      title: data,
      text: text,
      expanded: false,
      priority: priority,
    };
  }

  getExpirationDate = (fechaCaducidadDocumento: string) => {
    const [year, month, day] = fechaCaducidadDocumento.split('-');
    const clientIdExpireDate = new Date(+year, +month - 1, +day);
    return clientIdExpireDate;
  };

  isDocumentExpired(expireDate: Date): boolean {
    const expirationDate = moment(expireDate);
    const today = moment();
    return expirationDate.isBefore(today, 'day');
  }

  shouldShowDocumentNotification(expireDate: Date): boolean {
    const expirationDate = moment(expireDate);
    const dateLimit = moment().add(2, 'months');
    return expirationDate.isSameOrBefore(dateLimit);
  }
}
